import React, {Component} from "react";

class Selectable extends Component {
    onClick(e) {
        if (typeof(this.props.onClick) === "function") {
            this.props.onClick(e);
        }
    }

    render() {
        let stationType="";
        if (this.props.stationType){
            stationType = "station station-type-"+this.props.stationType
        }

        let userRole="";
        if (this.props.userRole){
            userRole = "user-role user-role-"+this.props.userRole
        }
        return (
            <div onClick={(e) => this.onClick(e)} className='selectable'>
                {/* <input type='checkbox'/> */}
                <span className={stationType+userRole}>
                    {this.props.title}  <i className="icon down"></i>
                </span>
            </div>
        )
    }
}

export default Selectable;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/Form_Elements/Selectable.js